import { render, staticRenderFns } from "./Bundle.vue?vue&type=template&id=142a4730"
import script from "./Bundle.vue?vue&type=script&lang=js"
export * from "./Bundle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('142a4730')) {
      api.createRecord('142a4730', component.options)
    } else {
      api.reload('142a4730', component.options)
    }
    module.hot.accept("./Bundle.vue?vue&type=template&id=142a4730", function () {
      api.rerender('142a4730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/bundles/Bundle.vue"
export default component.exports